var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 10,
    fill: "#FFF7F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 24.8333C26.923 24.8333 27.8252 24.5596 28.5926 24.0469C29.3601 23.5341 29.9582 22.8052 30.3114 21.9525C30.6646 21.0998 30.757 20.1615 30.577 19.2562C30.3969 18.351 29.9525 17.5195 29.2998 16.8668C28.6472 16.2142 27.8156 15.7697 26.9104 15.5897C26.0052 15.4096 25.0668 15.502 24.2141 15.8552C23.3614 16.2084 22.6326 16.8066 22.1198 17.574C21.607 18.3414 21.3333 19.2437 21.3333 20.1667C21.3333 21.4043 21.825 22.5913 22.7001 23.4665C23.5753 24.3417 24.7623 24.8333 26 24.8333ZM33 36.5C33.3094 36.5 33.6061 36.3771 33.8249 36.1583C34.0437 35.9395 34.1666 35.6428 34.1666 35.3333C34.1666 33.1674 33.3062 31.0902 31.7747 29.5586C30.2431 28.0271 28.1659 27.1667 26 27.1667C23.834 27.1667 21.7568 28.0271 20.2253 29.5586C18.6937 31.0902 17.8333 33.1674 17.8333 35.3333C17.8333 35.6428 17.9562 35.9395 18.175 36.1583C18.3938 36.3771 18.6906 36.5 19 36.5H33Z",
    fill: "#FC5719"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.44db2d8afaa9a856c75d5e763394c207.svg";
export { ForwardRef as ReactComponent };